import type {
  FieldKey,
  TagOption,
} from '@app/components/Modals/CombineClientsModal/types';
import { Tag } from '@app/components/TagsSelect/ui/Tag';
import type { ClientModel } from '@app/pages/DublicateClients/types';

export const getClientFieldValue = (
  client: ClientModel,
  field: FieldKey,
  tagOptions: TagOption[]
) => {
  switch (field) {
    case 'ClientName':
      return client.ClientName;
    case 'Phone':
      return client.Phone || '—';
    case 'Email':
      return client.Email || '—';
    case 'VK':
      return client.VK || '—';
    case 'Telegram':
      return client.Telegram || '—';
    case 'Instagram':
      return client.Instagram || '—';
    case 'Tags': {
      const clientTags = client.Tags ?? [];

      return clientTags.length > 0
        ? clientTags.map((id) => {
            const tag = tagOptions.find((t) => t.value === id);
            return (
              <Tag
                key={id}
                label={tag?.label}
                value={tag?.value as number}
                color={tag?.color}
                backgroundColor={tag?.backgroundColor}
                icon={tag?.icon}
                closable={false}
              />
            );
          })
        : '—';
    }
    default:
      return '—';
  }
};
